import React from 'react';
import PropTypes from 'prop-types';
import mime from 'mime';
import MediaViewer from 'components/MediaViewer';
import videoPlaceHolder from 'assets/video-placeholder.png';
import './attachment.scss';

const IMAGE = 'IMAGE_TYPE';
const VIDEO = 'VIDEO_TYPE';

class Attachment extends React.PureComponent {
    static propTypes = {
        src: PropTypes.string.isRequired,
        mediaType: PropTypes.string,
        allAttachments: PropTypes.arrayOf(PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
            url: PropTypes.string.isRequired,
        })),
    }

    static defaultProps = {
        mediaType: undefined,
        allAttachments: null,
    }

    constructor(props) {
        super(props);
        this.state = {
            show: false,
        };
    }

    get ext() {
        const { src } = this.props;
        return src.split('.').pop().split(/#|\?/)[0];
    }

    togglePreview = () => {
        this.setState((prevState) => ({
            show: !prevState.show,
        }));
    }

    checkType(mediaType) {
        if (/image/.test(mediaType)) {
            return IMAGE;
        }

        if (/video/.test(mediaType)) {
            return VIDEO;
        }
    }


    render() {
        const { src, mediaType, allAttachments } = this.props;
        const {
            show,
        } = this.state;

        const mimeType = mediaType ?? mime.getType(this.ext);
        const type = this.checkType(mimeType);

        return (
            <div className="attachment-container">
                <img
                    className="attachment"
                    onClick={ this.togglePreview }
                    src={ type === VIDEO ? videoPlaceHolder : src }
                    alt=""
                />
                <MediaViewer
                    show={ show }
                    fileIndex={ allAttachments.findIndex(att => att.url === src) }
                    files={ allAttachments }
                    togglePreview={ this.togglePreview }
                />
            </div>
        );
    }
}

export default Attachment;
